import { API_GET_ONE_PROFESSIONAL_RFP_SUCCESS } from '@/actions/ProfessionalRfpActions';
const initialState = {
    one: {},
};
export const professionalRfp = (state = initialState, result) => {
    const { payload, type } = result;
    switch (type) {
        case API_GET_ONE_PROFESSIONAL_RFP_SUCCESS: {
            return Object.assign(Object.assign({}, state), { one: Object.assign(Object.assign({}, state.one), { [payload.id]: payload }) });
        }
        default: {
            return state;
        }
    }
};
